import loadable from '@loadable/component';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router';

import { RedirectWithSession } from 'src/modules/app/components/RedirectWithSession';
import { NotFound } from 'src/modules/notFound';
import { TwoColumn } from 'src/shared/layouts';
import { Route as Routes } from 'src/shared/route';

import { Login } from '../Login';

const ForgotPassword = loadable(() => import('../ForgotPassword'), {
  resolveComponent: module => module.ForgotPassword,
});

const ResetPassword = loadable(() => import('../ResetPassword'), {
  resolveComponent: module => module.ResetPassword,
});

const ResetPasswordSuccess = loadable(() => import('../ResetPasswordSuccess'), {
  resolveComponent: module => module.ResetPasswordSuccess,
});

const ForgotPasswordSuccess = loadable(
  () => import('../ForgotPasswordSuccess'),
  {
    resolveComponent: module => module.ForgotPasswordSuccess,
  },
);

const SingleSignOnSuccess = loadable(() => import('../SingleSignOnSuccess'), {
  resolveComponent: module => module.SingleSignOnSuccess,
});

const SingleSignOnFailure = loadable(() => import('../SingleSignOnFailure'), {
  resolveComponent: module => module.SingleSignOnFailure,
});

const Router = () => (
  <TwoColumn.Container>
    <Switch>
      {/* Forgot + Reset Password redirects (continuing to support old URLs for now) */}
      <Redirect
        exact
        from={Routes.LOGIN_RESET_PASSWORD.path}
        to={Routes.LOGIN_RESET.path}
      />
      <Redirect
        exact
        from={Routes.LOGIN_FORGOT_PASSWORD.path}
        to={Routes.LOGIN_FORGOT.path}
      />

      {/* Forgot + Reset Password Routes */}
      <Route exact path={Routes.LOGIN_RESET_SUCCESS.path}>
        <ResetPasswordSuccess />
      </Route>
      <Route path={`${Routes.LOGIN_RESET.path}`}>
        <ResetPassword />
      </Route>
      <Route exact path={Routes.LOGIN_FORGOT_SUCCESS.path}>
        <ForgotPasswordSuccess />
      </Route>
      <Route exact path={Routes.LOGIN_FORGOT.path}>
        <ForgotPassword />
      </Route>

      {/* Login Routes */}
      <Route exact path={[Routes.LOGIN.path, Routes.LOGIN_SSO.path]}>
        <RedirectWithSession>
          <Login />
        </RedirectWithSession>
      </Route>
      <Route exact path={Routes.LOGIN_SSO_SUCCESS.path}>
        <SingleSignOnSuccess />
      </Route>
      <Route exact path={Routes.LOGIN_SSO_FAILURE.path}>
        <SingleSignOnFailure />
      </Route>

      {/* 404 */}
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  </TwoColumn.Container>
);

export { Router };
